import { resolveAccessTokenProvider } from './AccessTokenProvider';

export const getAccessToken = async (): Promise<string> => {
  const provider = resolveAccessTokenProvider();
  const accessToken = await provider.getAccessToken();

  return accessToken.encodedAccessToken;
};
